export default {
  computed: {
    nextQuery() {
      if (this.$route.query.next) {
        return `?next=${this.$route.query.next}`
      }
      return ''
    },
  },
}
